export const COLORS = {
  PRIMARY: '#FF03F3',
  PRIMARY_LIGHT: '#e6e6f5',
  PRIMARY_DARK: '#000080',
};

